export default __webpack_public_path__ + "static/media/daylotts100000_icon.50d624c9.svg";